import { useMutation } from 'react-query';
import { postWithHeaders } from 'Core/utils/platformApi';
import { useGetPaymentInfo } from 'Core/hooks/platform/useGetPaymentInfo';

export default function useAccountLookup() {
  const { data: paymentInfo } = useGetPaymentInfo();

  return useMutation((customerIdentityNumber) =>
    postWithHeaders(
      `send-otp`,
      customerIdentityNumber ? { customer_identity_number: customerIdentityNumber } : {},
      {
        headers: {
          external_reference_id: paymentInfo?.external_reference_id,
        },
      }
    )
  );
}
